import { render, staticRenderFns } from "./Remuneraciones.vue?vue&type=template&id=60e969b1&scoped=true&"
import script from "./Remuneraciones.vue?vue&type=script&lang=js&"
export * from "./Remuneraciones.vue?vue&type=script&lang=js&"
import style0 from "./Remuneraciones.vue?vue&type=style&index=0&id=60e969b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e969b1",
  null
  
)

export default component.exports